import { Gear } from '@phosphor-icons/react'
import { useHistory } from 'react-router-dom'

import stripeLogo from '@/assets/logos/stripe-logo.jpg'

import { IntegrationCard } from '../IntegrationCard'

export const StripeIntegrationComponent = () => {
  const history = useHistory()
  const STRIPE_ENABLED = process.env.REACT_APP_STRIPE_ENABLED === 'true'

  if (!STRIPE_ENABLED) return null
  return (
    <IntegrationCard.Root>
      <IntegrationCard.Header>
        <div className="flex items-center">
          <IntegrationCard.Image src={stripeLogo} />
          <IntegrationCard.Title>Stripe</IntegrationCard.Title>
        </div>
      </IntegrationCard.Header>
      <IntegrationCard.Content>
        <IntegrationCard.Description>
          Collect Cards on File with Stripe
        </IntegrationCard.Description>
      </IntegrationCard.Content>
      <IntegrationCard.Footer>
        <IntegrationCard.Button
          onClick={() => history.push('/settings/stripe')}
        >
          <Gear className="text-lg" /> Settings
        </IntegrationCard.Button>
      </IntegrationCard.Footer>
    </IntegrationCard.Root>
  )
}
